import { useLocation, useNavigate } from "react-router-dom";
import { useLocalSampleSummaryParams } from "../../../hooks";
import { pathToSS } from "../../../util";
import { YARA_MATCHES_CARD_ID } from "../../report_summary/cards/yara_matches/YaraMatchesCard";

import { settings } from "../../../../../shim/jsbridge";
import YaraDetections from "./YaraDetections";

const { FEATURE_IS_REPORT_SUMMARY_DEFAULT_LANDING_PAGE } = settings ?? {};

type Props = {
  matches: number;
};

const YaraDetectionsCard = ({ matches }: Props) => {
  const { hash = "", sourceId = "" } = useLocalSampleSummaryParams();
  const navigate = useNavigate();
  const { search } = useLocation();

  const handleSectionClick = () => {
    if (!matches) return;
    if (!FEATURE_IS_REPORT_SUMMARY_DEFAULT_LANDING_PAGE) return;

    const path = pathToSS(hash, sourceId, "");
    navigate(`${path}${search}#${YARA_MATCHES_CARD_ID}`);
  };

  return (
    <YaraDetections
      className={
        FEATURE_IS_REPORT_SUMMARY_DEFAULT_LANDING_PAGE &&
        matches &&
        "cursor-pointer"
      }
      matches={matches}
      onClick={handleSectionClick}
    />
  );
};

export default YaraDetectionsCard;
